import { DatePicker, Space } from "antd";
import Axios from "axios";
import moment from "moment";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import swal from "sweetalert";
import TableComponent from "../../../../_metronic/table/TableComponent";

const dateFormat = "YYYY-MM-DD";

const headers = [
  { label: "Customer name", key: "user_name" },
  { label: "Email", key: "email" },
  { label: "Phone", key: "phone" },
  { label: "Area", key: "area_name" },
  { label: "Store", key: "store_name" },
  { label: "Date", key: "created_at" },
  { label: "Via", key: "via" },
  { label: "IP Address", key: "ip_address" },
];

const HomePageVisit = () => {
  const {
    user: { accessToken, refreshToken },
    menuType
  } = useSelector((state) => state.auth);

  const [date_from, setDate_from] = useState(
    moment()
      .startOf("month")
      .format(dateFormat)
  );
  const [date_to, setDate_to] = useState(
    moment()
      .endOf("month")
      .format(dateFormat)
  );
  const [homePageVisitList, setHomePageVisitList] = useState([]);
  const current_date = moment().format('YYYY-MM-DD');
  const submitData = async () => {
    let start_date = moment(date_from).format(dateFormat);
    let end_date = moment(date_to).format(dateFormat);

    const { data, status } = await Axios.get(
      `${process.env.REACT_APP_API_URL}/report/getHomePageVisit/logReport/${menuType}/${start_date}/${end_date}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
          refreshToken: refreshToken,
        },
      }
    );

    if (status == 404 || status == 204) {
      swal({
        title: "No data Found",
        icon: "info",
      });
    } else if (!data.error) {
      if (data.data.length) {
        setHomePageVisitList(data.data);
      } else {
        setHomePageVisitList([]);
      }
    } else {
      swal({
        title: data.message,
        icon: "info",
      });
    }
  };

  // React Table
  const data = React.useMemo(() => homePageVisitList, [
    homePageVisitList,
  ]);

  const columns = React.useMemo(() => [
    {
      Header: "#",
      accessor: (row, index) => (
        <div className="d-flex align-items-center pl-4">
          <div>
            <h4 className="text-dark-75 font-weight-bolder mb-1 font-size-sm">
              {index + 1}
            </h4>
          </div>
        </div>
      ),
      minWidth: 50,
      width: 50,
    },
    {
      Header: "Customer name",
      accessor: "user_name",
      width: 200,
      paddingLeft: "0px",
    },

    {
      Header: "Email",
      accessor: "email",
      paddingLeft: "0px",
    },

    {
      Header: "Phone",
      accessor: "phone",
      paddingLeft: "0px",
    },
    {
      Header: "Area",
      accessor: "area_name",
      paddingLeft: "0px",
    },
    {
      Header: "Store",
      accessor: "store_name",
      width: 200,
      paddingLeft: "0px",
    },
    {
      Header: "Date",
      accessor: "created_at",
      paddingLeft: "0px",
    },
    {
      Header: "Via",
      accessor: "via",
      paddingLeft: "0px",
    },
    {
      Header: "IP Address",
      accessor: "ip_address",
      paddingLeft: "0px",
    },
  ]);


  return (
    <div>
      <div className="card custom-custom py-5 mb-10">
        <div className="card-header border-0 d-flex justify-content-between pb-0">
          <h3 className="card-title mb-5">Home Page Visit report</h3>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-md-3">
              <div
                className="d-flex"
                style={{
                  flexDirection: "column",
                }}
              >
                <label>
                  {" "}
                  Start Date
                  <span className="text-danger">*</span>
                </label>
                <Space direction="vertical" size={12}>
                  <DatePicker
                    style={{
                      width: "100%",
                      marginRight: "10px",
                    }}
                    format={dateFormat}
                    placeholder="MM/DD/YYYY"
                    defaultValue={moment(date_from)}
                    onChange={(date, dateString) => setDate_from(dateString)}
                  />
                </Space>
              </div>
            </div>
            <div className="col-md-3">
              <div
                className="d-flex"
                style={{
                  flexDirection: "column",
                }}
              >
                <label>
                  {" "}
                  End Date
                  <span className="text-danger">*</span>
                </label>
                <Space direction="vertical" size={12}>
                  <DatePicker
                    style={{
                      width: "100%",
                      marginRight: "10px",
                    }}
                    format={dateFormat}
                    placeholder="MM/DD/YYYY"
                    defaultValue={moment(date_to)}
                    onChange={(date, dateString) => setDate_to(dateString)}
                  />
                </Space>
              </div>
            </div>
            <div className="col-md-3 mt-4">
              <button
                onClick={() => {
                  submitData();
                }}
                className="btn btn-primary w-75 mt-5"
              >
                search
              </button>
            </div>
          </div>

          {homePageVisitList?.length > 0 && (
            <TableComponent
              columns={columns}
              data={data}
              hideAddButton={true}
              lists={homePageVisitList}
              csv={true}
              excelHeader={headers}
              filename={`Home Page Visit Log_${current_date} .csv`}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default HomePageVisit;
